import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class DataService {
private baseUrl:any="https://www.bdfshopping.com/manage_app_user/"
  constructor(public http: HttpClient) { }

  public getcountry_list(){
    return this.http.get('../assets/json/CountryCodes.json')
}

public getcountry_name_list(){
  return this.http.get('../assets/json/countries.json')
}

public user_register(post_params){
  
    let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post(this.baseUrl+"sign_in/registration_submit/",JSON.stringify(post_params),headers)

}

public login(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json', })
  return this.http.post(this.baseUrl+"sign_in/login_action/",JSON.stringify(post_params),headers)

}

public otp_verify(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':this.baseUrl })
  return this.http.post(this.baseUrl+"sign_in/otp_verify/",JSON.stringify(post_params),headers)

}

public password_checking(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/check_old_password/",JSON.stringify(post_params),headers)

}

public update_password(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/change_password_action/",JSON.stringify(post_params),headers)

}

public update_profile_image(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/update_profile_image/",JSON.stringify(post_params),headers)

}
public get_my_profile(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/myaccount/",JSON.stringify(post_params),headers)

}
public update_profile(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/user_profile_update/",JSON.stringify(post_params),headers)

}


public home_data(){
  
 
  return this.http.get(this.baseUrl+"home_controllr/get_home_data/")

}

public get_category(){
  
 
  return this.http.get(this.baseUrl+"home_controllr/get_category/")

}

public get_product(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_product/",JSON.stringify(post_params),headers)

}

public get_product_details(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/product_details/",JSON.stringify(post_params),headers)

}

public add_to_cart(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/add_to_cart",JSON.stringify(post_params),headers)
}
public forgotpassword(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/forogot_password",JSON.stringify(post_params),headers)

}
public view_cart(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_cart_items",JSON.stringify(post_params),headers)
}

public item_incriment(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/add_qty_cart",JSON.stringify(post_params),headers)
}

public item_decriment(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/product_list/remove_qty_cart",JSON.stringify(post_params),headers)
}

public add_to_wish_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/add_to_wishlist",JSON.stringify(post_params),headers)
}

public delete_from_cart(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/delete_cart",JSON.stringify(post_params),headers)
}

public get_deli_addres(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_billing_details",JSON.stringify(post_params),headers)
}

public aa_deli_addres(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/payment_method",JSON.stringify(post_params),headers)
}

public get_wallet_balance_check(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/get_wallet_balance_check",JSON.stringify(post_params),headers)
}

public send_wallet_otp(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/send_wallet_otp",JSON.stringify(post_params),headers)
}


public place_order(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/place_order",JSON.stringify(post_params),headers)
}

public my_order(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/get_my_order",JSON.stringify(post_params),headers)
}

public my_wish_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/wishlist",JSON.stringify(post_params),headers)
}

public delete_wish_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/my_account/delete_wishlist",JSON.stringify(post_params),headers)
}

public check_old_password(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/check_old_password",JSON.stringify(post_params),headers)
}
public update_user_password(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/change_password_action",JSON.stringify(post_params),headers)
}
public add_manage_address(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/add_new_address",JSON.stringify(post_params),headers)
}



public manage_address_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/get_address",JSON.stringify(post_params),headers)
}

public add_new_address(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/add_new_address",JSON.stringify(post_params),headers)
}

public cancel_order(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/cancel_order",JSON.stringify(post_params),headers)
}

public make_default(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/my_account/make_default",JSON.stringify(post_params),headers)
}

public delete_address(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/my_account/delete_address",JSON.stringify(post_params),headers)
}

public submit_notify(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/home_controllr/subscriber_submit",JSON.stringify(post_params),headers)
}
public get_all_product(){
  
  return this.http.get(this.baseUrl+"home_controllr/getsearchlist")
}


public get_terms(){
  
  return this.http.get(this.baseUrl+"/home_controllr/get_terms")
}

public get_about_info(){
  
  return this.http.get(this.baseUrl+"/home_controllr/get_about_info")
}

public get_privacy(){
  
  return this.http.get(this.baseUrl+"/home_controllr/get_privacy")
}
public savedevicetoken(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json'})
  return this.http.post(this.baseUrl+'push_notification/update_token',JSON.stringify(post_params),headers)

}
public get_notification(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/notificationList",JSON.stringify(post_params),headers)
}
public is_view_notofication(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"push_notification/is_view_notification/",JSON.stringify(post_params),headers)
}


public new_notification_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/notification_list",JSON.stringify(post_params),headers)
}

public submit_review(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/review_submitAction",JSON.stringify(post_params),headers)
}

public get_filter_data(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_filter_data",JSON.stringify(post_params),headers)
}

public product_price_low_high(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/product_price_low_high",JSON.stringify(post_params),headers)
}

public product_price_high_low(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/product_price_high_low",JSON.stringify(post_params),headers)
}

public filter_by_brand(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/filter_by_brand",JSON.stringify(post_params),headers)
}

public get_wallet_details(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"my_account/get_wallet_details",JSON.stringify(post_params),headers)
}

public review_like_action(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/review_like_action",JSON.stringify(post_params),headers)
}

public review_dislike_action(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/review_dislike_action",JSON.stringify(post_params),headers)
}




public get_support_content(){
 
  return this.http.get(this.baseUrl+"home_controllr/get_support_content")
}

public get_product_by_search(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_product_by_search",JSON.stringify(post_params),headers)
}


public get_product_by_banner_slider(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"product_list/get_offerProductlist",JSON.stringify(post_params),headers)
}

public get_location(){
 
  return this.http.get(this.baseUrl+"home_controllr/get_location")
}

public get_service_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home_controllr/get_service_list",JSON.stringify(post_params),headers)
}
public get_service_details(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home_controllr/get_service_details",JSON.stringify(post_params),headers)
}

public booking_submit_action(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home_controllr/booking_submit_action",JSON.stringify(post_params),headers)
}

public my_service_bookings(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home_controllr/my_service_bookings",JSON.stringify(post_params),headers)
}

public cancel_booking(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home_controllr/cancel_booking",JSON.stringify(post_params),headers)
}





// /product_list/payment_method
///product_list/add_to_wishlist

}
